module.exports = __webpack_public_path__ + "img/nav-header-mobile-wedding.22fc595.jpg";